import ip from 'icepick';

import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import { ReducerType } from '../types/Model';
import {
  GET_LINKED_FASTAG_FAILURE,
  GET_LINKED_FASTAG_REQUEST,
  GET_LINKED_FASTAG_RESET,
  GET_LINKED_FASTAG_SUCCESS,
  UPDATE_STATUS_POPUP,
  UPDATE_USER_VEHICLE,
  UPDATE_USER_VEHICLE_FASTAGS,
} from './type';

const initialState: ReducerType = ip.freeze({
  linkedFastag: [],
  getLinkedFastag: { ...API_DATA_FORMAT },
  statusPopup: {
    show: false,
    data: null,
  },
  userVehicleFastags: [],
  selectedVehicleId: null,
});

export function fastagReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LINKED_FASTAG_REQUEST: {
      state = ip.setIn(
        state,
        ['getLinkedFastag', 'apiStatus'],
        API_STATUS.in_progress
      );
      return state;
    }

    case GET_LINKED_FASTAG_SUCCESS: {
      state = ip.setIn(
        state,
        ['getLinkedFastag', 'apiStatus'],
        API_STATUS.success
      );
      state = ip.setIn(state, ['linkedFastag'], action.payload);
      return state;
    }

    case GET_LINKED_FASTAG_FAILURE: {
      state = ip.setIn(
        state,
        ['getLinkedFastag', 'apiStatus'],
        API_STATUS.failure
      );
      state = ip.setIn(state, ['getComponentList', 'apiError'], action.payload);
      return state;
    }

    case GET_LINKED_FASTAG_RESET: {
      state = ip.setIn(
        state,
        ['getLinkedFastag'],
        initialState.getLinkedFastag
      );
      state = ip.setIn(state, ['linkedFastag'], initialState.linkedFastag);
      return state;
    }

    case UPDATE_STATUS_POPUP: {
      if (action.payload.show !== undefined)
        state = ip.setIn(state, ['statusPopup', 'show'], action.payload.show);
      if (action.payload.data !== undefined)
        state = ip.setIn(state, ['statusPopup', 'data'], action.payload.data);
      return state;
    }

    case UPDATE_USER_VEHICLE_FASTAGS: {
      state = ip.setIn(state, ['userVehicleFastags'], action.payload);
      return state;
    }

    case UPDATE_USER_VEHICLE: {
      state = ip.setIn(state, ['selectedVehicleId'], action.payload);
      return state;
    }

    default:
      return state;
  }
}

export default fastagReducer;
